import { render, staticRenderFns } from "./materialSelector.vue?vue&type=template&id=3aaf5d9f&scoped=true&"
import script from "./materialSelector.vue?vue&type=script&lang=js&"
export * from "./materialSelector.vue?vue&type=script&lang=js&"
import style0 from "./materialSelector.vue?vue&type=style&index=0&id=3aaf5d9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf5d9f",
  null
  
)

export default component.exports